// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const houndoom_mega: PokeData = {
  "id": 10048,
  "name": "houndoom-mega",
  "height": 19,
  "weight": 495,
  "base_experience": 210,
  "types": [
    PokeType.DARK,
    PokeType.FIRE
  ],
  "api_moves": [
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "smog",
    "feint-attack",
    "crunch",
    "beat-up",
    "odor-sleuth",
    "howl",
    "embargo",
    "nasty-plot",
    "thunder-fang",
    "fire-fang",
    "foul-play",
    "inferno"
  ],
  "moves": [
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "crunch",
    "thunder-fang",
    "fire-fang",
    "lash-out",
    "fire-punch",
    "flatter",
    "dark-bargain",
    "night-daze",
    "blaze-kick"
  ],
  "evolution_chain": {
    "id": 118,
    "item": null,
    "species": [
      {
        "name": "houndour",
        "order": 261,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "houndoom",
        "order": 262,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 228,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 136,
    "ability_power": 166
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
